{
  "title": "Remote access sessions",
  "activeOnly": "Running",
  "all": "All",
  "terminate": "End",
  "terminateFailed": "Ending the session failed",
  "terminateForbidden": "Only the organization administrator may end sessions that belong to others.",
  "listFailed": "The session list is unavailable",
  "emptyActive": "Nobody is connected right now",
  "emptyEver": "There have been no sessions yet",
  "emptyHint": "A session appears here as soon as someone opens the VNC console. Only the organization administrator may end a session that belongs to someone else.",
  "trafficHint": "Received from the machine / sent to the machine",
  "kind": {
    "vnc": "VNC",
    "ssh": "Terminal",
    "videoLive": "Video",
    "videoArchive": "Archive"
  },
  "column": {
    "who": "Who",
    "machine": "Machine",
    "startedAt": "Started",
    "duration": "Duration",
    "traffic": "Traffic",
    "from": "From"
  },
  "endReason": {
    "clientClosed": "closed by the user",
    "serverClosed": "the server dropped the connection",
    "agentOffline": "the site agent disconnected",
    "terminated": "ended by an administrator",
    "gatewayShutdown": "the gateway was stopped",
    "handshakeFailed": "the connection could not be established",
    "ticketExpired": "the ticket expired",
    "error": "failure"
  }
}
